<template>
  <router-view></router-view>
</template>

<script>
import { defineComponent, onMounted, onUnmounted } from "vue";
import { store } from '@/store';

export default defineComponent({
  setup() {
    const appName = window.g.appName;
    document.title = appName

    function clear(){
      localStorage.removeItem("userInfo");
      localStorage.removeItem("menusId");
      localStorage.removeItem("token");
    }

    //取得cookie    
    function getCookie(name) {
      const nameEQ = name + "=";
      if(document.cookie.indexOf(nameEQ) !== -1){
        return true;
      } else {
        return false;
      }
      
    }
    if(!getCookie('token')){
      //清除
      clear();
    }

    const state = store.state;

    function handleVisibility(){
        //页面可见性，页面可见说明是切回当前页面
      // 如果页面可见 -- 检查store里面的用户id和localstroge的用户id是否一致
      // 不一致则刷新页面
      if(!document.hidden){
        let vuexUserId = '';
        if (state.user.userInfo) {
          vuexUserId = state.user.userInfo.id;
        }

        const userInfoJson = localStorage.getItem('userInfo')
        let localUserId = '';
        if (userInfoJson !== null) {
          const userInfo = JSON.parse(userInfoJson);
          localUserId = userInfo.id;
        }

        // 用户id不一致时刷新页面
        if(vuexUserId && localUserId && vuexUserId !== localUserId){
          history.go(0);
        }
      }
    }

    onMounted(()=>{
      // 监听文档可见性
      document.addEventListener('visibilitychange', handleVisibility);
    })


    onUnmounted(()=>{
      document.removeEventListener('visibilitychange', handleVisibility)
    })

  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #fff;
}
</style>
